<template>
    <section class="tables">
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">
                        <h2 class="card-title">{{ $t('names.orderRequests.name') }}</h2>
                        <p class="card-description">{{ $t('names.orderRequests.description') }}</p>
                        <b-table striped hover :items="items" :fields="fields" @row-clicked="openDetails" class="clickable"></b-table>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <b-pagination
                v-model="pageNr"
                :total-rows="allPages"
                per-page="1"
                first-number
                last-number
                @change="handlePageChange"
                align="right">
            </b-pagination>
        </div>
    </section>
</template>

<script>
    import axios from 'axios'
    import {Const} from '../../../config'
    import moment from 'moment'

    export default {
        name: 'OrderRequestList',
        data() {
            return {
                pageNr: 1,
                allPages: "",
                items: [],
                fields: [
                    {
                        key: 'id',
                        label: 'ID',
                        sortable: true,
                        thStyle: 'width: 75px;'
                    },
                    {
                        key: 'createdDate',
                        label: this.$t('forms.created'),
                        sortable: true,
                        formatter: value => {
                            return moment(value).format('DD.MM.YYYY, HH:mm');
                        }
                    },
                    {
                        key: 'name',
                        label: this.$t('forms.name'),
                        sortable: true,
                        formatter: value => {
                            return this.trimEllip(value, 20)
                        }
                    },
                    {
                        key: 'surname',
                        label: this.$t('forms.surname'),
                        sortable: true,
                        formatter: value => {
                            return this.trimEllip(value, 20)
                        }
                    },
                    {
                        key: 'phone',
                        label: this.$t('forms.contactPhone'),
                        sortable: false
                    },
                    {
                        key: 'email',
                        label: this.$t('forms.email'),
                        sortable: true,
                        formatter: value => {
                            return this.trimEllip(value, 30)
                        }
                    }
                ]
            }
        },
        mounted() {
          this.refreshPage()
        },
        methods: {
            openDetails(item) {
                this.$router.push('/order-request/' + item.id)
            },
            trimEllip(s, length) {
                return s.length > length ? s.substring(0, length) + "..." : s;
            },
            handlePageChange(value) {
                this.pageNr = value;
                this.refreshPage()

            },
            refreshPage() {
                if (this.pageNr == null || this.pageNr === "") {
                    this.pageNr = 1
                }
                axios.get(Const.API_HOST + '/admin/orders/' + this.pageNr)
                    .then(body => {
                        this.items = body.data.orders
                        this.pageNr = body.data.pageNr
                        this.allPages = body.data.allPages
                    }).catch(error => {
                        // eslint-disable-next-line no-console
                        console.error(error)
                    })
            }
        }
    }
</script>

<style scoped>
    .clickable /deep/ tbody td {
        cursor: pointer;
    }

</style>
